"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFolderModalVisibleState = void 0;
const react_1 = __importDefault(require("react"));
const folder_1 = require("../../../server/models/folder");
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const FoldersRoute_1 = __importDefault(require("../../../routes/FoldersRoute"));
const RedirectTo_1 = __importDefault(require("../../../utilities/RedirectTo"));
const react_router_dom_1 = require("react-router-dom");
const SaveInFolderModal_1 = __importDefault(require("../Modals/SaveInFolderModal"));
exports.createFolderModalVisibleState = (0, recoil_1.atom)({
    key: 'createFolderModalVisibleState',
    default: false,
});
const CreateFolderModal = ({ defaultFolderId, t, }) => {
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.createFolderModalVisibleState);
    const history = (0, react_router_dom_1.useHistory)();
    const successCallback = (res) => {
        if (res)
            (0, RedirectTo_1.default)({ history, path: `${FoldersRoute_1.default.path}/${res.id}` });
    };
    const saveInFolderModalProps = {
        id: 'createFolderModal',
        defaultFolderId: defaultFolderId,
        formSubmitCallback: async (title, folderId) => await (0, folder_1.createFolder)({ Name: title, ParentId: folderId.toString() }),
        successCallback: successCallback,
        successMessage: t('folderCreateSuccess'),
        failureMessage: t('folderCreateFail'),
        errorMessage: t('folderCreateError'),
        titleName: 'createFolder',
        titleValidationCallback: async (title, folderId) => await (0, folder_1.verifyFolderNameUniqueIn)(title, folderId.toString()),
        placeholder: t('folderCreatePlaceholder'),
        duplicateErrorMessage: t('folderCreateDuplicate'),
        headerText: t('folderCreateHeader'),
        primaryButtonText: t('folderCreateButton'),
        autoFocus: true,
        visible: visible,
        setVisible: (isVisible) => setVisible(isVisible),
        t: t,
    };
    return react_1.default.createElement(SaveInFolderModal_1.default, { ...saveInFolderModalProps });
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(CreateFolderModal);
